import { SupportPlanRevision } from '~clients/models';

import { buildSlice, CommonState } from '~libs/reduxUtils';

import { create, getAll, getOne, typePrefix } from '~clients/actions/clientSupportPlanRevisions';

const initialState: CommonState<SupportPlanRevision> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  row: undefined,
};

const slice = buildSlice<CommonState<SupportPlanRevision>, SupportPlanRevision>(typePrefix, initialState, {
  commonConfig: { getAll },
  extraReducers: (builder) => {
    builder.addCase(getOne.fulfilled, (state, action) => {
      const row = action.payload.data;

      // flatten category_id to help service type filtering
      if (Array.isArray(row.plan_services)) {
        row.plan_services = row.plan_services.map((ps: any) => ({
          ...ps,
          category_id: ps.service?.category_id ?? null,
        }));
      }

      state.loading = 'fulfilled';
      state.row = row;
    });
    builder.addCase(create.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.message = action.payload.message;
    });
  },
  customActions: {
    syncCategories(state, action) {
      if (!state.row) return;
      state.row.plan_categories = [...action.payload];
    },
    syncServices(state, action) {
      if (!state.row) return;
      state.row.plan_services = [...action.payload];
    },
  },
});

// default actions
export const { clear, updateParams, syncCategories, syncServices } = slice.actions;
export default slice.reducer;
